import styled from 'styled-components';

import { headerVariables } from '../../components/Header/HeaderStyle';

import {
  breakpoints,
  colors,
  fontFamily,
  functions,
  zIndex,
} from '../../ui/variables';

export const NoInstitutionStyle = styled.main`
  background-color: ${colors.veryPaleBlue};
  min-height: 100vh;
  padding: ${headerVariables.main.height.iphone + 36}px 20px 36px;
  width: 100%;

  @media (min-width: ${breakpoints.ipadLandscape.width}px) {
    align-items: center;
    display: flex;
    justify-content: center;
    padding: ${headerVariables.main.height.iphone + 64}px 64px 64px;
  }

  .email-confirmation-content {
    @media (min-width: ${breakpoints.ipadLandscape.width}px) {
      align-items: stretch;
      background-color: ${colors.softBlue};
      border-radius: 20px;
      display: flex;
      max-width: 1344px;
      min-height: 60vh;
      overflow: hidden;
      position: relative;
      width: 100%;
    }

    .image-section {
      display: none;

      @media (min-width: ${breakpoints.ipadLandscape.width}px) {
        display: block;
        flex-basis: 50%;
        position: relative;
      }

      .logo-wrapper {
        left: 50%;
        position: absolute;
        top: ${functions.responsive.vw(
          40,
          64,
          breakpoints.ipadLandscape.width,
          breakpoints.fullHd.width
        )};
        transform: translateX(-50%);
        width: 25%;

        @media (min-width: ${breakpoints.fullHd.width}px) {
          top: 64px;
        }

        svg,
        .logo {
          display: block;
          height: auto;
          width: 100%;
        }
      }

      .register-illustration {
        bottom: 0;
        display: block;
        height: auto;
        left: 50%;
        max-height: 396px;
        position: absolute;
        transform: translateX(-50%);
        width: calc(100% - (2 * 32px));
      }
    }

    .form-section {
      background-color: ${colors.white};
      border-radius: 20px;
      padding: 40px 44px;

      @media (min-width: ${breakpoints.ipadLandscape.width}px) {
        border-radius: 0;
        border-bottom-left-radius: 20px;
        border-top-left-radius: 20px;
        flex-basis: 50%;
        padding: 80px 64px;
      }

      .form-content {
        @media (min-width: ${breakpoints.ipadLandscape.width}px) {
          margin: 0 auto;
          max-width: 468px;
        }

        .form-head {
          .form-head-title {
            ${fontFamily.sourceSansPro.bold};
            color: ${colors.softBlue};
            font-size: 30px;
            line-height: 36px;
            margin-bottom: 8px;
          }

          .form-head-description {
            ${fontFamily.sourceSansPro.regular};
            color: ${colors.veryDarkGray};
            font-size: 14px;
            line-height: 20px;
            margin-bottom: 58px;

            .user-email {
              ${fontFamily.sourceSansPro.bold};
            }
          }
        }

        .input-code {
          ${fontFamily.sourceSansPro.bold};
          background-color: ${colors.white};
          border-radius: 4px;
          border: 1px solid ${colors.grayishBlue};
          display: inline-block;
          font-size: 16px;
          line-height: 20px;
          margin-right: 8px;
          padding: 6px 8px;
          text-align: center;
          width: 30px;

          @media (min-width: ${breakpoints.fullHd.width}px) {
            border-radius: 8px;
            font-size: 32px;
            line-height: 40px;
            margin-right: 16px;
            padding: 12px 16px;
            width: 60px;
          }

          &:last-of-type {
            margin-right: 0;
          }
        }

        .submit-wrapper {
          margin-top: 142px;
        }
      }
    }
  }

  .snack-bar-wrapper {
    ${zIndex.hills};
    left: 0;
    position: fixed;
    top: ${headerVariables.main.height.iphone}px;
    width: 100%;

    @media (min-width: ${breakpoints.ipadLandscape.width}px) {
      top: ${headerVariables.main.height.iphone}px;
    }
  }
`;
